import {useEffect, useRef} from 'react'

/**
 * Custom hook that debounces a callback function
 * @param {Function} callback - The callback function to execute after the delay
 * @param {Array} dependencies - The dependency array that triggers the debounce
 * @param {number} delay - The debounce delay in milliseconds (default: 500ms)
 */
const useDebouncedCallback = (callback, dependencies, delay = 500) => {
  const callbackRef = useRef(callback)

  // Keep the callback ref updated
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const handler = setTimeout(() => {
      callbackRef.current()
    }, delay)

    return () => clearTimeout(handler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, delay])
}

export default useDebouncedCallback
